<template>
  <div class="milestone-sidebar-content">
    <div
      class="milestones-sidebar-list"
      :style="`${show_details?'width: 50px;':''}`"
      >
      <slot name="list" :milestones="milestones"/>
    </div>
    <div v-if="show_details" class="milestones-sidebar-details">
      <slot name="details"/>
    </div>
  </div>
</template>
<script>
  export default {
    props: ['show_details', 'milestones']
  }
</script>
<style>
  .milestone-sidebar-content {
    display: flex;
    height: calc(100% - 48px);
    /* background-color: green; */
  }
  .milestones-sidebar-list {
    width: 100%;
    flex-shrink: 0;
    overflow-y: auto;
    overflow-x: hidden;
    transition: width 0.15s ease-in-out;
  }
  .milestones-sidebar-details {
    width: 100%;
    /* border-left: 1px solid #212121; */
    padding-left: 3px;
    background-color: var(--v-color-3-base);
    /* background-color: #424242 */
  }
</style>
